import { ClientResponse } from '../redux/api/customer/customer.model';
import { TwTagsOption } from '../components/TwTagsField/TwTagsField';
import { FactoringCompany, UserResponse } from '../providers/User/User.model';

export const getCustomerContactEmails = (
  client: ClientResponse,
  showFactoringContact?: boolean,
  factoringCompany?: FactoringCompany
): TwTagsOption[] => {
  const contactEmails: TwTagsOption[] = [];

  if (showFactoringContact && factoringCompany?.email_address) {
    contactEmails.push({
      id: '',
      label: factoringCompany.name,
      subLabel: factoringCompany?.email_address,
      value: factoringCompany?.email_address
    });
  }

  if (client.contacts && client.contacts.length > 0) {
    client.contacts?.forEach((c) => {
      c.email_address &&
        contactEmails.push({
          id: '',
          label: c.first_name + ' ' + c.last_name,
          subLabel: c.email_address,
          value: c.email_address
        });
    });
  }

  if (client.billing_email) {
    contactEmails.push({
      id: '',
      label: client.name,
      subLabel: client.billing_email,
      value: client.billing_email
    });
  }

  return contactEmails;
};

/**
 * Shows email suggestions based on:
 * - All contacts for the customer
 * - Billing email for the customer
 * - User's email
 * - Tenant accounting email
 * - Tenant factoring email
 * @param client
 * @param tenant
 * @param showFactoringContact
 */
export const getPreviewInvoiceSuggestions = (
  client: ClientResponse,
  tenant: UserResponse | undefined,
  showFactoringContact?: boolean
): TwTagsOption[] => {
  const factoringCompany = tenant?.factoringCompany;
  const accountingEmail = tenant?.tenantAccountingSettings?.accounting_email;
  const userEmail = tenant?.email_address;
  const contactEmails: TwTagsOption[] = [];

  if (accountingEmail) {
    contactEmails.push({
      id: '',
      label: tenant.company_name,
      subLabel: accountingEmail,
      value: accountingEmail
    });
  }

  if (userEmail) {
    contactEmails.push({
      id: '',
      label: tenant.first_name + ' ' + tenant.last_name,
      subLabel: userEmail,
      value: userEmail
    });
  }

  if (showFactoringContact && factoringCompany?.email_address) {
    contactEmails.push({
      id: '',
      label: factoringCompany.name,
      subLabel: factoringCompany?.email_address,
      value: factoringCompany?.email_address
    });
  }

  if (client.contacts && client.contacts.length > 0) {
    client.contacts?.forEach((c) => {
      c.email_address &&
        contactEmails.push({
          id: '',
          label: c.first_name + ' ' + c.last_name,
          subLabel: c.email_address,
          value: c.email_address
        });
    });
  }

  if (client.billing_email) {
    contactEmails.push({
      id: '',
      label: client.name,
      subLabel: client.billing_email,
      value: client.billing_email
    });
  }

  return contactEmails;
};
